import styled from "@emotion/styled";

export const Address = styled.address`
  font-size: ${(props: any) => props.theme.typography.subtext};
  font-style: normal;
  vertical-align: sub;
`;
